import * as React from "react";
import { connect } from "react-redux";
import Loader from "../Generics/Loader";
import {
  MODE_CURRENT_GCP_REQUEST_VIEW,
  userOpensCurrentGCPRequestPage,
} from "./scenarios";
import { ICurrentGCPRequestRouteProps } from "../../redux/modules/router/routes";
import CurrentGcpRequestPage from "./GcpRequestView/CurrentGcpRequestPage";

export default connect()(
  ({ customerId, siteId }: ICurrentGCPRequestRouteProps) => (
    <Loader
      asyncAction={() => userOpensCurrentGCPRequestPage(customerId, siteId)}
    >
      {(gcpRequestMode: string) => {
        switch (gcpRequestMode) {
          case MODE_CURRENT_GCP_REQUEST_VIEW:
            return <CurrentGcpRequestPage />;

          default:
            return (
              <div>
                Unexpected Error: this mode is not supported ({gcpRequestMode})
                [CurrentGcpRequestViewPage]
              </div>
            );
        }
      }}
    </Loader>
  ),
);
